import { render, staticRenderFns } from "./runningout_ofstock.vue?vue&type=template&id=616fa432&"
import script from "./runningout_ofstock.vue?vue&type=script&lang=js&"
export * from "./runningout_ofstock.vue?vue&type=script&lang=js&"
import style0 from "./runningout_ofstock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports